import { ConfigService } from '@axo/config';
import { Main } from '@axo/form/feature/axo-form-v2/lib/forms/Denmark/LoanApplication/Main';
import { MarketCountryCode } from '@axo/shared/types';
import { mount } from '../../mount';

ConfigService.initialize('lendme.dk');

mount(
  <Main
    baseUrl={import.meta.env.VITE_API_URL}
    redirectUrl={import.meta.env.VITE_DK_INSURANCE}
    legacyUrl={import.meta.env.VITE_DK_LEGACY_API}
  />,
  {
    market: MarketCountryCode.Denmark,
    theme: 'lendme',
    launchDarklyKey: 'dk-wl',
  }
);
